import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import ButtonPrimary from "shared/Button/ButtonPrimary"
import StayCard from "components/StayCard/StayCard"
import { STANZE_REALI } from "data/villaGrecoDatiStanze/stanze"

const SectionGridFeaturePlaces = () => {
  const navigate = useNavigate()
  const [stanzeMostrate, setStanzeMostrate] = useState(4) // Mostra 4 stanze inizialmente

  const gestisciClickCard = (id) => {
    // Porta l'utente alla pagina dinamica dei dettagli della stanza
    // qui io metto il percorso che dico io che reindirizza direttamente ai componenti statici
    // navigate(`/listing-stay-detail/${id}`)
    navigate(`/dettagli-appartamento/${id}`)
  }

  // const gestisciClickCard = (id) => {
  //   // Verifica l'id e naviga al componente specifico
  //   switch (id) {
  //     case "1":
  //       navigate("/n1-belvedere") // Componente specifico per stanza 1
  //       break
  //     case "2":
  //       navigate("/n2-belvedere") // Componente specifico per stanza 2
  //       break
  //     case "3":
  //       navigate("/stanze/n3-bouganville") // Componente specifico per stanza 3
  //       break
  //     default:
  //       navigate(`/stanze/${id}`) // Componente generico o fallback
  //       break
  //   }
  // }

  const caricaAltreStanze = () => {
    setStanzeMostrate((prev) => prev + 4) // Incrementa di 4 stanze ogni volta
  }

  const renderizzaCard = (stanza) => {
    return (
      <StayCard
        key={stanza.id}
        data={stanza}
        onClick={() => gestisciClickCard(stanza.id)} // Passa la funzione click
      />
    )
  }

  return (
    <div className="nc-SectionGridFeaturePlaces relative m-5">
      <div className="text-center mb-4">
        <h2 className="text-3xl font-semibold">Scopri i nostri appartamenti</h2>
        <p className="mt-2 text-neutral-500">Scegli il tuo preferito e scopri tutti i dettagli</p>
      </div>
      <div className="grid gap-6 md:gap-8 grid-cols-1 md:grid-cols-4">
        {STANZE_REALI.slice(0, stanzeMostrate).map((stanza) => renderizzaCard(stanza))}
      </div>
      {stanzeMostrate < STANZE_REALI.length && (
        <div className="flex mt-16 justify-center items-center">
          <ButtonPrimary onClick={caricaAltreStanze}>Carica altri Appartamenti</ButtonPrimary>
        </div>
      )}
    </div>
  )
}

export default SectionGridFeaturePlaces
